import styles from "../../Styles/ComponentStyles/global.module.scss";
import pulsatingLoaderImg from "../../assets/Images/Profile/pulsatingLoaderImg.png"

const PulsatingLoader = () => {
    return (
        <div className={styles.loaderContainer}>
            <div className={styles.pulseWrapper}>
                <div className={styles.pulse}></div>
                <div className={styles.pulse}></div>
                <div className={styles.pulse}></div>
                <img src={pulsatingLoaderImg} alt="Extracting" className={styles.centerImage} />
            </div>
            <p className={styles.loadingText}>Extracting data... This may take a moment, please wait...</p>
            <p className={styles.loadingSubText}>Do not refresh or close this, or the data may be lost.</p>
        </div>
    );
};

export default PulsatingLoader;